import React, { useContext, useState } from 'react';
import tw from 'twin.macro';
import { Icon } from '../icon';
import { TimesIcon } from 'icons';
import { Kudos } from '../kudos';
import { CommentReplyForm } from '../form';
import { UserContext, CommentsContext, CommentContext } from '../context';
import { Author, Date, Reply, DeluxeTools, ModeratorTools, ReportComment, Separator } from './';
import { kudoComment } from 'services/comments';
import { gaEvent } from 'services/ga';
import { Small } from '../text';
import { Marker } from '../marker';

const subcommentInit = { active: false, id: null };

export const CommentFooter = ({ comment, subComment, parentComment }) => {
  const {
    id,
    creation_datetime: creationDatetime,
    kudos_count: kudosCount,
    author: authorId,
    child_comments: childComments,
    report_count: reportCount,
    username,
  } = comment;

  const [subCommentForm, setSubCommentForm] = useState(subcommentInit);

  const { user } = useContext(UserContext);
  const { showAllChildComments, setShowAllChildComments } = useContext(CommentContext);
  const { authorsList, openComments, lastAddedComment } = useContext(CommentsContext);

  const parentId = parentComment ? parentComment.id : id;
  const parentAuthor = parentComment
    ? authorsList.find((author) => author.id === parentComment.author)
    : authorId;
  const parentCommentUser =
    parentComment && subComment && parentAuthor ? parentAuthor.username : null;
  const author =
    typeof authorId === 'number' ? authorsList.find((author) => author.id === authorId) : authorId;

  return (
    <>
      <div tw='flex items-center mt-1'>
        <div css={[tw`flex items-center justify-start flex-shrink-0 flex-grow w-full`]}>
          <div tw='flex-row md:flex-wrap items-start items-center overflow-hidden'>
            <div tw='flex justify-start items-center'>
              <div tw='flex-row'>
                <div tw='flex justify-start items-center -mb-1.5'>
                  <DeluxeTools />
                  <Author
                    newbie={author && author.newbie}
                    author={username ? { username } : author}
                    authorId={authorId}
                  />
                  <div tw='ml-2'>
                    {user && author && author.username === user.name && <Marker label='ik' />}
                  </div>
                </div>
                <div tw='flex md:flex-wrap items-center'>
                  <Date date={creationDatetime} />
                  {childComments && childComments.length > 0 && (
                    <>
                      <span
                        tw='cursor-pointer transition-all'
                        onClick={() => setShowAllChildComments(!showAllChildComments)}
                      >
                        <Small tw='text-brand'>
                          <Separator />
                          {childComments.length}
                        </Small>
                      </span>
                    </>
                  )}
                  {((comment && comment.approved) || (user && user.moderate)) && (
                    <>
                      {user && openComments && Number(id) !== Number(lastAddedComment) && (
                        <Reply
                          comment={comment}
                          setSubCommentForm={() => setSubCommentForm({ active: true, id })}
                        />
                      )}
                      <ReportComment commentId={id} reportCount={reportCount} />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div tw='flex flex-1 flex-shrink-0 justify-end'>
            <Kudos
              type='comments'
              numOfKudos={kudosCount}
              clickUp={() => {
                gaEvent('dmp_comment', 'kudo_up');
                return kudoComment({
                  commentId: id,
                  direction: 'up',
                });
              }}
              clickDown={() => {
                gaEvent('dmp_comment', 'kudo_down');
                return kudoComment({
                  commentId: id,
                  direction: 'down',
                });
              }}
            />
          </div>
        </div>
      </div>

      {subCommentForm.active && subCommentForm.id === comment.id && (
        <div tw='mt-2 relative'>
          <div
            tw='text-brand cursor-pointer'
            onClick={() => {
              setSubCommentForm(subcommentInit);
            }}
          >
            <Icon
              Type={TimesIcon}
              tw='cursor-pointer hover:text-danger transition-all absolute top-0 right-0'
              data-action='close'
            />
          </div>
          <CommentReplyForm
            comment={comment}
            subComment={subComment}
            parent={{ id: parentId, username: parentCommentUser }}
            hide={!subCommentForm.active}
            setSubCommentForm={() => setSubCommentForm(subcommentInit)}
          />
        </div>
      )}
      {comment && comment.id && user && user.moderate && (
        <ModeratorTools
          comment={comment}
          authorId={authorId}
          author={username ? { username } : author}
        />
      )}
    </>
  );
};
